import React, {FC, useState, useContext} from "react"
import CopyToClipboard from "react-copy-to-clipboard"

import IconBase, {IconTypes} from "@irati/ui/src/Icon"
import env from "@irati/utils/env"
import {stopPropagationAndPrevent} from "@irati-web/wallet/src/utils/stopBubbleEvent"
import DrawerContext from "@irati/ui/src/AppContainer/Context/DrawerContext"
import Button, {TextButton} from "@irati/ui/src/Button"
import {useTheme} from "@irati/ui/src/global/useTheme"
import authentication from "@irati/auth"
import {triggerSuccessToast} from "@irati/ui/src/ToastAlert/triggerToast"
import {useIntl} from "@irati/utils/lang"
import {PRODUCTION} from "@irati/utils/constants/environment"
import tracking from "@irati-tracking/platform/platform"

import {Wrapper} from "./Icons/styled"

const SHARE_RECOGNITION_TITLE = "Perkbox recognition"

interface Props {
  recognitionId: string
  isPrimaryButton?: boolean
}

const RecognitionShareIcon: FC<Props> = ({recognitionId, isPrimaryButton = false}) => {
  const [isHovered, setIsHovered] = useState(false)
  const {setDrawerOpen} = useContext(DrawerContext)
  const {formatMessage} = useIntl()
  const theme = useTheme()

  const getRecognitionUrl = () => {
    const {subdomain} = authentication.business()
    const path = `recognition/polls/recognition/${recognitionId}`
    const tld = env.ENVIRONMENT_NAME === PRODUCTION ? "com" : "net"
    return `https://${subdomain}.perkbox.${tld}/${path}?utm_source=recognition&utm_medium=share_link`
  }
  const title = SHARE_RECOGNITION_TITLE
  const url = getRecognitionUrl()

  const handleClickShare = (e: any) => {
    stopPropagationAndPrevent(e)
    setDrawerOpen({
      title,
      url,
      alertText: "recognition.recognition.shareText",
      source: "recognition",
      type: "recognition",
      entity_id: recognitionId
    })
  }

  const handleCopyClick = (e: any) => {
    stopPropagationAndPrevent(e)
    tracking.share({source: "recognition", type: "recognition", entity_id: recognitionId})
    triggerSuccessToast(formatMessage({id: "platform.shareToDrawer.toast"}))
  }

  const sharingData = {
    title,
    url
  }

  const ShareContent = isPrimaryButton ? (
    formatMessage({id: "platform.share.button"})
  ) : (
    <Wrapper onMouseOver={() => setIsHovered(true)} onMouseOut={() => setIsHovered(false)}>
      <IconBase icon={IconTypes.share} color={isHovered ? theme.colors.primary1 : theme.colors.utility.ink} />
    </Wrapper>
  )
  const ShareButton = isPrimaryButton ? Button : TextButton

  if (navigator.canShare && navigator.canShare(sharingData)) {
    return (
      <ShareButton onClick={handleClickShare} primary={isPrimaryButton} full marginBottom={isPrimaryButton ? 1 : 0}>
        {ShareContent}
      </ShareButton>
    )
  }
  return (
    <CopyToClipboard text={url}>
      <ShareButton onClick={handleCopyClick} primary={isPrimaryButton} full marginBottom={isPrimaryButton ? 1 : 0}>
        {ShareContent}
      </ShareButton>
    </CopyToClipboard>
  )
}

export default RecognitionShareIcon
